import {icon} from './icons.js';
import {escapeHtml, previewUrl, applyPreviewFallback} from './tour-data.js';

// Pano2VR owns positioning and navigation. Vite owns these hotspot graphics.
export function mountHotspots(player, skin, getNode) {
 const decorate = (element, id) => {
  if (!element) return;
  if (element.dataset.kmHotspot) {
   const image = element.querySelector('img');
   if (image?.hidden) applyPreviewFallback(image,[getNode(id)].filter(Boolean));
   return;
  }
  element.dataset.kmHotspot = id;
  element.classList.add('km-hotspot');
  const title = getNode(id)?.title || player.getNodeUserdata(id)?.title || id;
  element.innerHTML = `<button type="button" class="km-hotspot__button" aria-label="${escapeHtml(title)}">${icon('arrow')}</button><span class="km-hotspot__preview" aria-hidden="true"><img src="${previewUrl(id)}" alt=""><span>${escapeHtml(title)}</span></span>`;
  element.querySelector('img').addEventListener('error', (event) => {
   if (!applyPreviewFallback(event.currentTarget,[getNode(id)].filter(Boolean))) event.currentTarget.hidden = true;
  });
 };
 const original = skin.addSkinHotspot.bind(skin);
 skin.addSkinHotspot = (hotspot) => {
  const instance = original(hotspot), id = /^\{(.+)\}$/.exec(hotspot.url || '')?.[1];
  if (id && instance) decorate(instance.__div, id);
  return instance;
 };
 const refresh = () => skin.findElements('ht_node', false).forEach((el) => decorate(el, el.ggElementNodeId()));
 player.addListener('changenode', refresh);
 player.addListener('configloaded', refresh);
 refresh();
 return refresh;
}
